import { apiClient } from "../apiClient";
export const BSKT_DOT_HOC_ENDPOINT = "bskt-dot-hoc";
export const bsktDotHocApi = {
  SelectAll: () => apiClient.get(`${BSKT_DOT_HOC_ENDPOINT}`),
};
